import { createApi } from '@reduxjs/toolkit/query/react'
import { BaseRequest } from '../models'
import { baseQueryWithTokenRefresh } from '../../common/baseQuery'
import { Nullable } from '../../common/Nullable'

import { parseJwt } from '../../common/jwt'

const _BASE_URL = import.meta.env.REACT_APP_AUTH_API_BASE_URL!

export type Dashboard = {
  id: string
  name: string
  domain: string
  token: string
}

export type RawBiDashboardsResponse = {
  biToken: string
  dashboards: Dashboard[]
}

export type BiDashboardsResponse = {
  dashboards: Dashboard[]
}

export type DashboardFilter = {
  filterKey: string
  filterValue: string
  filterOperator: string
}

export interface DashboardRequest extends BaseRequest {
  filters?: Nullable<DashboardFilter[]>
  dashboardIds?: Nullable<string[]>
}

export const insightsApi = createApi({
  reducerPath: 'insightsApi',
  baseQuery: baseQueryWithTokenRefresh(_BASE_URL),
  tagTypes: ['Insights'],
  endpoints: (builder) => ({
    getBiDashboards: builder.query<Dashboard[], DashboardRequest>({
      query: (request) => {
        const { accountId, filters, dashboardIds } = request
        return {
          url: `/v1/accounts/${accountId}/bi-dashboards`,
          method: 'POST',
          body: {
            filters: filters,
            internalIds: dashboardIds,
          },
        }
      },
      transformResponse: ({ dashboards, biToken }: RawBiDashboardsResponse) => {
        const token = parseJwt(biToken)
        return dashboards.map((d) => {
          return { id: d.id, name: d.name, domain: token.aud, token: biToken }
        })
      },
    }),
  }),
})

export const { useGetBiDashboardsQuery } = insightsApi
